import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { userInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const UserUpdate = ({ title }) => {
  const location = useLocation();
  const cooId = location.pathname.match(/\/update-user\/(\d+)/)?.[1];
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [options, setOptions] = useState([]);
  const [roptions, setRoptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [allRoles, setAllRoles] = useState([]);

  // const token = true;
  let [token] = useState(localStorage.getItem("token"))

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    // console.log("token login", token)
    window.location.href = "/";
  };

  useEffect(() => {
    console.log("token", token)
    const fetchUser = async () => {
      try {
        const response = await fetch(`${serverUrl}/user/${cooId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();

        // Destructure to remove password and keep other fields
        const { password, ...userData } = data.data;

        const rnames = userData.role_names.split(",");
        const rid = userData.role_id.split(",").sort((a, b) => a - b);

        const namelist = [];
        for (let i = 0; i < rnames.length; i++) {
          const name = rnames[i];
          const id = rid[i];
          namelist.push({ value: id, label: name });
        }

        const status = userData.status;
        setSelectedStatus(
          status === 1
            ? { value: status, label: "Active" }
            : { value: status, label: "Inactive" }
        );
        setSelectedRoles(namelist);
        setInputValues(userData); // Now without password
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch user data.");
      }
    };

    if (cooId) {
      fetchUser();
    }
  }, [cooId]);
  const handleRoleSelectChange = (selectedOptions) => {
    const selected = selectedOptions || [];
    setSelectedRoles(selected);

    const roleIds = selected.map((option) => option.value);
    setInputValues({
      ...inputValues,
      role_id: roleIds,
    });

    const selectedIds = selected
      .map((option) => option.value)
      .sort((a, b) => a - b);
    const updatedOptions = allRoles.filter(
      (role) => !selectedIds.includes(role.value)
    );
    setRoptions(updatedOptions);
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  useEffect(() => {
    console.log("issue here")
    roles();
  }, []);

  const roles = async () => {
    try {
      const response = await fetch(`${serverUrl}/role_ids`);
      if (!response.ok) {
        throw new Error("Failed to fetch roles");
      }
      const data = await response.json();
      const namelist = data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setAllRoles(namelist);

      const selectedIds = selectedRoles
        .map((role) => parseInt(role.value))
        .sort((a, b) => a - b);

      const filteredOptions = namelist.filter(
        (role) => !selectedIds.includes(parseInt(role.value))
      );
      setRoptions(filteredOptions);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch roles data.");
    }
  };

  useEffect(() => {
    if (allRoles.length > 0 && selectedRoles.length > 0) {
      const selectedIds = selectedRoles
        .map((role) => parseInt(role.value))
        .sort((a, b) => a - b);
      const filteredOptions = allRoles.filter(
        (role) => !selectedIds.includes(parseInt(role.value))
      );
      setRoptions(filteredOptions);
    }
  }, [allRoles, selectedRoles]);

  const center_name = async () => {
    try {
      const response = await fetch(`${serverUrl}/center_id`);
      if (!response.ok) {
        throw new Error("Failed to fetch center data");
      }
      const data = await response.json();
      const namelist = [];
      for (let i = 0; i < data.data.length; i++) {
        const name = data.data[i].name;
        const id = data.data[i].id;
        namelist.push({ value: id, label: name });
      }
      setOptions(namelist);
    } catch (error) {
      console.error("Error fetching center data:", error);
      toast.error("Failed to fetch center data.");
    }
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("role_id", inputValues.role_id);
    formData.append("email", inputValues.email);
    formData.append("phone_no", inputValues.phone_no);
    formData.append("password", inputValues.password);
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_user/${cooId}`, {
        method: "PUT",
        body: formData,
      });

      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("User updated successfully!");
        setTimeout(() => {
          navigate("/user");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {userInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "role_id" ? (
                              <Select
                                options={roptions}
                                isMulti
                                value={selectedRoles}
                                onChange={handleRoleSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/user")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update User
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
      {/* {Checking ? (
        <>
        </>
      ) : (
        redirectToLogin()
      )} */}
    </ThemeProvider>
  );
};

export default UserUpdate;